import { Link, NavLink, useNavigate } from "react-router-dom";
import { Search, Menu, X } from "lucide-react";
import { useEffect, useState } from "react";

const NAV = [
    { to: "/", label: "Home" },
    { to: "/series", label: "Web Series" },
    { to: "/viral", label: "Viral Videos" },
    { to: "/ai-creative", label: "AI Creative" },
    { to: "/coming-soon", label: "Coming Soon" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const nav = useNavigate();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
                scrolled ? "backdrop-blur-xl bg-black/80 border-b border-white/10" : "backdrop-blur-md bg-black/40"
            }`}
        >
            <div className="mx-auto max-w-[1600px] px-6 lg:px-10 h-16 flex items-center gap-8">
                <Link to="/" data-testid="nav-logo" className="flex items-center shrink-0">
                    <span className="font-display font-black text-[26px] sm:text-[28px] leading-none tracking-[0.02em]">
                        <span className="text-white">APNI </span><span className="text-[#FFD400]">DUKAN</span>
                    </span>
                </Link>

                <nav className="hidden lg:flex items-center gap-6 flex-1">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                `text-sm font-medium tracking-wide transition-colors duration-200 hover:text-[#FFD400] ${
                                    isActive ? "text-[#FFD400]" : "text-white/80"
                                }`
                            }
                            end={n.to === "/"}
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="ml-auto flex items-center gap-3">
                    <button
                        data-testid="nav-search-btn"
                        onClick={() => nav("/search")}
                        className="p-2 rounded-full hover:bg-white/10 transition-colors"
                        aria-label="Search"
                    >
                        <Search className="w-5 h-5 text-white" />
                    </button>
                    <button
                        data-testid="nav-mobile-toggle"
                        onClick={() => setMobileOpen((v) => !v)}
                        className="lg:hidden p-2 rounded-full hover:bg-white/10 transition-colors"
                        aria-label="Menu"
                    >
                        {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>

            {mobileOpen && (
                <div className="lg:hidden backdrop-blur-xl bg-black/90 border-t border-white/10">
                    <div className="px-6 py-4 flex flex-col gap-3">
                        {NAV.map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                data-testid={`nav-mobile-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                                onClick={() => setMobileOpen(false)}
                                className={({ isActive }) =>
                                    `text-base font-medium py-2 ${isActive ? "text-[#FFD400]" : "text-white/85"}`
                                }
                                end={n.to === "/"}
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
}
